import React from 'react'
import Link from 'gatsby-link'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import Divider from 'components/Divider'
import SubscribeForm from '../forms/SubscribeForm'
import FollowBar from './FollowBar'
import Section from './Section'

const styles = (theme) => ({
  container: {
    maxWidth: 1250,
    margin: 'auto',
    padding: 20,
  },
  text: {
    color: theme.palette.text.lighter,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em',
    },
  },
  blueLink: {
    fontWeight: 500,
    color: '#09aafa',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.8em',
    },
    '&:hover': {
      color: '#74e6ff',
    },
  },
  copyright: {
    fontWeight: 300,
    color: '#fff',
  },
})

const Footer = ({ classes, theme }) => (
  <div style={{ background: theme.palette.primary.main }}>
    <div className={classes.container}>
      <FollowBar height={100} bright />
      <Divider
        offset={25}
        style={{
          background: theme.palette.borders.ghost,
          opacity: 0.3,
        }}
      />
      <Grid spacing={24} container>
        <Section
          innerSections={[
            {
              header: 'Change Your Life With Us',
              body: (
                <Typography
                  component={Link}
                  to="/"
                  className={classes.blueLink}
                  gutterBottom
                  paragraph
                >
                  healthfulinspired.com
                </Typography>
              ),
            },
            {
              header: 'Find Inspiration',
              body: (
                <Typography
                  component={Link}
                  to="/weight-loss-stories"
                  className={classes.blueLink}
                  gutterBottom
                  paragraph
                >
                  WEIGHT LOSS STORIES
                </Typography>
              ),
            },
            {
              header: 'Stay Physically Confident',
              body: (
                <Typography
                  component={Link}
                  to="/weight-loss-workouts"
                  className={classes.blueLink}
                  gutterBottom
                  paragraph
                >
                  WORKOUTS CURATED FOR WEIGHT LOSS
                </Typography>
              ),
            },
            {
              header: 'Never Fall Behind',
              body: (
                <Typography
                  component={Link}
                  to="/weight-loss-articles"
                  className={classes.blueLink}
                  gutterBottom
                  paragraph
                >
                  WEIGHT LOSS ARTICLES, CONTENT AND TIPS
                </Typography>
              ),
            },
          ]}
        />
        <Section
          innerSections={[
            {
              header: 'Subscribe',
              body: (
                <div>
                  <Typography className={classes.text}>
                    Become a subscriber today to start receiving newsletters of
                    the latest, best trending health content delivered straight
                    to your inbox. (You only need to enter your email)
                  </Typography>
                  <div style={{ position: 'relative', minHeight: 170 }}>
                    <SubscribeForm />
                  </div>
                </div>
              ),
            },
          ]}
        />
        <Section
          innerSections={[
            {
              header: 'Amazon Associates Disclosure',
              body: (
                <Typography className={classes.text} gutterBottom paragraph>
                  We are a participant in the Amazon Services LLC Associates
                  Program, an affiliate advertising program designed to provide
                  a means for us to earn fees by advertising linking to
                  Amazon.com and affiliated sites.
                </Typography>
              ),
            },
            {
              header: 'Privacy Policy',
              body: (
                <Typography
                  component={Link}
                  to="/privacy-policy"
                  className={classes.blueLink}
                  gutterBottom
                  paragraph
                >
                  Read our privacy policy
                </Typography>
              ),
            },
            {
              body: (
                // eslint-disable-next-line
                <Typography className={classes.copyright} variant="caption">
                  Copyright &copy; 2018 Healthful&Inspired
                </Typography>
              ),
            },
          ]}
        />
      </Grid>
    </div>
  </div>
)

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js